import { assign, keyBy, orderBy } from 'lodash';

import {
  ADD_EXPENSE_BUCKETS_WITH_TAGS,
  ADD_EXPENSE_BUCKETS_WITH_TAGS_BY_ID,
  EXPENSE_BUCKETS_ADD_EXPENSE_BUCKETS_FOR_USER,
  ExpenseBucketsWithTagsAction,
  SET_EXPENSE_BUCKET_WITH_TAGS_BY_ID_LOADING,
  SET_EXPENSE_BUCKET_WITH_TAGS_LOADING
} from '@Actions/expenseBucketsWithTagsActions';

import { IExpenseTagBucketModel } from '@Shared/models';

export interface IExpenseTagBucketState {
  expenseBucketsWithTagsLoading: boolean;
  expenseBucketsWithTagsByIdLoading: boolean;
  dropdownExpenseBucketsWithTags: IExpenseTagBucketModel[];
  activeExpenseBucketsWithActiveTags: IExpenseTagBucketModel[];
  activeExpenseBucketsById: Record<string, IExpenseTagBucketModel>;
  expenseBucketsByUser: Record<string, IExpenseTagBucketModel[]>;
  // null value is used to validate if this was loaded or not
  // in TransactionsDataGrid component when submitting the transaction
  expenseTagBucketsById: Record<string, IExpenseTagBucketModel> | null;
}

export const defaultState: IExpenseTagBucketState = {
  expenseBucketsWithTagsLoading: false,
  expenseBucketsWithTagsByIdLoading: false,
  dropdownExpenseBucketsWithTags: [],
  activeExpenseBucketsWithActiveTags: [],
  activeExpenseBucketsById: {},
  expenseBucketsByUser: {},
  expenseTagBucketsById: null
};

export function expenseTagBucketsReducer(state = defaultState, action: ExpenseBucketsWithTagsAction): IExpenseTagBucketState {
  function order(buckets: IExpenseTagBucketModel[]) {
    buckets.forEach(function (bucket) {
      bucket.expense_tags = orderBy(bucket.expense_tags, ['disabled', 'name'], ['asc', 'asc']);
    });
    return buckets;
  }

  switch (action.type) {
    case ADD_EXPENSE_BUCKETS_WITH_TAGS: {
      const activeBuckets = [];
      for (const bucket of action.payload) {
        if (!bucket.disabled) {
          const activeBucket = { ...bucket };
          const activeTags = [];
          for (const tag of bucket.expense_tags) {
            if (!tag.disabled) {
              activeTags.push({ ...tag });
            }
          }
          activeBucket.expense_tags = activeTags;
          activeBuckets.push(activeBucket);
        }
      }
      return assign({}, state, {
        dropdownExpenseBucketsWithTags: order(action.payload.filter((bucket: IExpenseTagBucketModel) => bucket.is_dropdown)),
        activeExpenseBucketsWithActiveTags: order(activeBuckets),
        activeExpenseBucketsById: keyBy(activeBuckets, 'id')
      });
    }
    case EXPENSE_BUCKETS_ADD_EXPENSE_BUCKETS_FOR_USER: {
      return {
        ...state,
        expenseBucketsByUser: {
          ...state.expenseBucketsByUser,
          [action.payload.userId]: action.payload.expenseBuckets
        }
      };
    }
    case SET_EXPENSE_BUCKET_WITH_TAGS_LOADING:
      return {
        ...state,
        expenseBucketsWithTagsLoading: action.payload
      };

    case SET_EXPENSE_BUCKET_WITH_TAGS_BY_ID_LOADING:
      return {
        ...state,
        expenseBucketsWithTagsByIdLoading: action.payload
      };

    case ADD_EXPENSE_BUCKETS_WITH_TAGS_BY_ID:
      return {
        ...state,
        expenseTagBucketsById: keyBy(action.payload, 'id')
      };
    default:
      return state;
  }
}
